<script>
    import { Link } from 'svelte-routing';
    import { tooltip } from "@svelte-plugins/tooltips";

    import AimTooltip from '../component/AimTooltip.svelte';

    export let inmateUrn;
    export let name;
    export let tooltipText;
    export let tooltipOptions;
</script>

<td>
    <Link to="/history/{inmateUrn}" class="focus-outline">
        <span use:tooltip={{
            content: {
                component: AimTooltip,
                props: tooltipText
            },
            ...tooltipOptions
        }}>
            {name}
        </span>
    </Link>

</td>